window.o_apps = window.o_apps_init({
  document,
  httpRequest() {
    return new XMLHttpRequest();
  },
  eventQBus: window.o_global.eventQBus,
  appsAndroid: window.o_apps_android,
  cmp: () => window.cmp,
  privacyPage: () => window.o_privacyPage,
  wishlist: () => window.o_wishlist,
  htmlLocation: window.location,
  exactag: window.exactag,
  userAgent: navigator.userAgent,
  webkitMessageHandlers: window.webkit ? window.webkit.messageHandlers : null,
  firebaseEventNameKey: "event_name",
  firebaseParameterKey: {
    kFIRParameterItemID: "item_id",
    kFIRParameterItemName: "item_name",
    kFIRParameterItemCategory: "item_category",
    kFIRParameterQuantity: "quantity",
    kFIRParameterValue: "value",
  },
  navigator,
});

/**
 *
 *
 *
 */
window.o_global.eventQBus.emit("apps.global.assets-loaded");
window.o_global.eventQBus.emit("assets.module.loaded", {
  moduleId: "apps.global.assets",
});
